import React, { useState, useEffect } from 'react';
import HeaderMenu from '../Header/HeaderMenu';
import axiosApi from '../Utils/axiosApi';
import checkPermission from '../Utils/checkPermission';
import {
  Button,
  TextField,
  Grid,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';

const CreateHostelerNotification = ({
  isDialog = false,
  isUpdate = false,
  initialData = {},
  recipientHostelerId,
  recipientHostelId,
  onSuccess,
}) => {
  const [formData, setFormData] = useState({
    id: '',
    title: '',
    message: '',
  });

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // ✅ Prefill data when updating
  useEffect(() => {
    if (isUpdate && initialData) {
      setFormData({
        id: initialData.id || '',
        title: initialData.title || '',
        message: initialData.message || '',
      });
    }
  }, [isUpdate, initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const dto = {
        id: formData.id || undefined,
        title: formData.title,
        message: formData.message,
        type: 'FEEDBACK', // ✅ Hardcoded
        priority: 'HIGH', // ✅ Hardcoded
        recipientHostelId: Number(recipientHostelId),
        recipientHostelerId: Number(recipientHostelerId),
      };

      const url = isUpdate
        ? '/hostelNotification/updateHostelNotification'
        : '/hostelNotification/createHostelNotification';

      await axiosApi.post(url, { hostelNotificationDTO: dto });

      setSuccessMessage(`Notification ${isUpdate ? 'updated' : 'created'} successfully!`);
      setFormData({ id: '', title: '', message: '' });

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error submitting notification:', error);
      setErrorMessage('Failed to submit notification. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="create-notification">
      {!isDialog && <HeaderMenu />}
      <Paper elevation={2} sx={{ p: 3 }}>
        {successMessage && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {successMessage}
          </Alert>
        )}
        {errorMessage && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Title */}
            <Grid item xs={12}>
              <TextField
                name="title"
                value={formData.title}
                onChange={handleChange}
                fullWidth
                label="Subject"
                size="small"
                required
              />
            </Grid>

            {/* Message */}
            <Grid item xs={12}>
              <TextField
                name="message"
                value={formData.message}
                onChange={handleChange}
                fullWidth
                label="Suggestions / Complaints"
                multiline
                rows={3}
                size="small"
                required
              />
            </Grid>

            {/* Submit */}
            <Grid item xs={12}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={
                  submitting || !checkPermission('Notification', 'Notifications', 'UPDATE')
                }
				
              >
                {submitting ? (
                  <CircularProgress size={24} color="inherit" />
                ) : isUpdate ? (
                  'Update'
                ) : (
                  'Create'
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </div>
  );
};

export default CreateHostelerNotification;
